import http from './httpService';
/*global API */
const competencesEndpoint = `${API}/api/Competence`;
const competencesEndpointForWizard = `${API}/api/Competence`;
// Not yet supported in backend
// export function getCompetenec(id) {
//   return http.get(competencesEndpoint + "/" + id, id);
// }

export function getCompetences(paramsTmp) {
  return http.get(competencesEndpoint, {
    params: {
      Name: paramsTmp.Name,
      Type: paramsTmp.Type?.value,
      PageNumber: paramsTmp.PageNumber,
      PageSize: paramsTmp.PageSize,
    },
  });
}

export async function createNewCompetence(competence) {
  return http.post(competencesEndpoint, {
    name: competence.competenceName,
    type: competence.competenceType?.value,
    field: competence.competenceField,
    description: competence.competenceDescription,
  });
}

export async function createNewCompetenceFromWizard(competence) {
  return http.post(competencesEndpoint + '/fromWizard', {
    name: competence.competenceName,
    type: competence.competenceType,
    field: competence.competenceField,
    description: competence.competenceDescription,
  });
}

export async function updateCompetence(competence) {
  return http.put(competencesEndpoint, {
    id: competence.competenceId,
    name: competence.competenceName,
    type: competence.competenceType?.value,
    field: competence.competenceField,
    description: competence.competenceDescription,
  });
}

export async function deleteCompetence(competenceId) {
  return http.delete(competencesEndpoint, {
    params: {
      competenceId: competenceId,
    },
  });
}
